import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderRecoCardComponent } from './order-reco-card.component';
import { PaymentOtdModule } from '../payment-otd/payment-otd.module';



@NgModule({
  declarations: [OrderRecoCardComponent],
  imports: [
    CommonModule,
    PaymentOtdModule
  ],
  exports: [OrderRecoCardComponent],
  bootstrap: [OrderRecoCardComponent]
})
export class OrderRecoCardModule {
  getComponent() {
    return OrderRecoCardComponent;
  }
}
